import { useCallback, useEffect } from 'react';
import Loader from '@/components/Loader/Loader';
import { useDispatch } from 'react-redux';
import { userGetUsersSuccess } from '@/modules/user/userActions';
import { User, UserRole } from '@/modules/user/userTypes';
import { useGetUserQuery } from '../hooks/useGetUserQuery';

type RetriveUserProps = {
	onUserRoleUpdated: () => void;
	onUserRoleTimout: () => void;
};

export const RetriveUser = ({
	onUserRoleUpdated,
	onUserRoleTimout
}: RetriveUserProps) => {
	const dispatch = useDispatch();

	const updateUserData = useCallback(
		(user: User) => {
			dispatch(userGetUsersSuccess([user]));
		},
		[dispatch]
	);

	const { data, refetch } = useGetUserQuery();

	useEffect(() => {
		const interval = setInterval(() => {
			if (
				data?.data.data.role &&
				data?.data.data.role !== UserRole.PreTrial
			) {
				onUserRoleUpdated();
				updateUserData(data?.data.data);
				return;
			}

			refetch();
		}, 1000);

		return () => clearInterval(interval);
	}, [data, onUserRoleUpdated, refetch, updateUserData]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			onUserRoleTimout();
		}, 15 * 1000);

		return () => clearTimeout(timeout);
	}, [onUserRoleTimout]);

	return (
		<div className="flex flex-1 flex-col items-center justify-center gap-10">
			<Loader />
			<p className="max-w-[50%] text-dm-grey">
				Please wait while we retrieve your user role. This may take a
				few seconds.
			</p>
		</div>
	);
};
